import React from 'react';
import { campo, etiqueta, opcional } from './estilos';
import { Paso } from './Paso';
import type { DatosContacto, MetodoPago } from '../types/pedido';
const PAGOS: {
  valor: MetodoPago;
  label: string;
}[] = [{
  valor: 'Efectivo',
  label: 'Efectivo'
}, {
  valor: 'Transferencia',
  label: 'Transfer.'
}, {
  valor: 'MercadoPago',
  label: 'Mercado Pago'
}];
interface Props {
  datos: DatosContacto;
  onDato: (campo: keyof DatosContacto, valor: string) => void;
}
export function PasoContacto({
  datos,
  onDato
}: Props) {
  return <Paso num="03" titulo="¿Con quién hablamos?" data-id="element-60" data-mp="g3zovjitaamv">
      <div className="mb-3 grid grid-cols-2 gap-2.5" data-id="element-61" data-mp="bbq046tfngm6">
        <label className="block" data-id="element-62" data-mp="baexiabq4ewn">
          <span className={etiqueta} data-id="element-63" data-mp="6cwluc6bnlky">Nombre</span>
          <input type="text" value={datos.nombre} onChange={e => onDato('nombre', e.target.value)} placeholder="Anto Bando" autoComplete="name" className={campo} required data-id="element-64" data-mp="6c3lpu1vbubs" />
        </label>
        <label className="block" data-id="element-65" data-mp="qjqbjp54lay9">
          <span className={etiqueta} data-id="element-66" data-mp="qkrv6i07j5rl">WhatsApp</span>
          <input type="tel" value={datos.tel} onChange={e => onDato('tel', e.target.value)} placeholder="11 5555 4444" autoComplete="tel" className={campo} required data-id="element-67" data-mp="vjmc1eem6k92" />
        </label>
      </div>

      <fieldset className="mb-3 block" data-id="element-68" data-mp="7ts4ncd2dnw7">
        <legend className={etiqueta} data-id="element-69" data-mp="7rxf1kqul7ls">Cómo pagás</legend>
        <div className="grid grid-cols-3 gap-2" data-id="element-70" data-mp="csbrrg3e95q5">
          {PAGOS.map(p => {
          const activo = datos.pago === p.valor;
          return <label key={p.valor} className="relative block cursor-pointer" data-id="element-71" data-mp="3v01572o2s19u">
                <input type="radio" name="pago" value={p.valor} checked={activo} onChange={() => onDato('pago', p.valor)} className="peer absolute h-0 w-0 opacity-0" data-id="element-72" data-mp="2v6zqzmvag1f" />
                <span className={`block rounded-field border px-1 py-2.5 text-center text-[13.5px] transition-colors duration-150 ease-soft peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-accent ${activo ? 'border-accent bg-accent-soft font-bold text-accent' : 'border-line bg-surface-2 font-medium text-ink'}`} data-id="element-73" data-mp="366g4slgbw3ur">
                  {p.label}
                </span>
              </label>;
        })}
        </div>
      </fieldset>

      <label className="block" data-id="element-74" data-mp="3g1qbvnll31fe">
        <span className={etiqueta} data-id="element-75" data-mp="3b4q334xcnkkl">
          Alguna aclaración <span className={opcional} data-id="element-76" data-mp="3b3yggjlqcx6g">(opcional)</span>
        </span>
        <textarea value={datos.notas} onChange={e => onDato('notas', e.target.value)} placeholder="Tocar timbre del portero. Si no estoy, dejar con el encargado." className={`${campo} min-h-16 resize-y leading-normal`} data-id="element-77" data-mp="cepw7ljloe55" />
      </label>
    </Paso>;
}